module.exports = __webpack_public_path__ + "assets/img/section-1-landing-page-pj.fd9a59a6.png";